var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3125C12 13.5938 12.5625 13 13.2812 13H26.6875C27.4062 13 28 13.5938 28 14.3125C28 14.625 27.875 14.9062 27.6875 15.125L22.5 21.5312V26C22.5 26.5625 22.0312 27 21.4688 27C21.25 27 21.0312 26.9375 20.8438 26.7812L17.9688 24.5C17.6562 24.25 17.5 23.9062 17.5 23.5312V21.5312L12.2812 15.125C12.0938 14.9062 12 14.625 12 14.3125ZM13.6875 14.5L18.8125 20.7812C18.9375 20.9375 19 21.0938 19 21.25V23.4062L21 25V21.25C21 21.0938 21.0312 20.9375 21.1562 20.7812L26.2812 14.5H13.6875Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ec3976dfa0817b2365334b2afdd9a60b.svg";
export { ForwardRef as ReactComponent };